import { styled as o, css as e } from "styled-components";
import { CaptionHeavy as r } from "../../../styles/typography/index.js";
import { DealStampSkeleton as i } from "../DealStamp/skeleton.js";
import { DealButtonSkeleton as a } from "../DealButton/style.js";
import { MediaQuery as l } from "../../../styles/variables.js";
import { SmartLink as m } from "../../../components/SmartLink/index.js";
import { skeletonFadeAnimation as p } from "../../../styles/animation.js";
import { Theme as t } from "../../../styles/themes/index.js";
import { DealActionBar as c } from "../DealActionBar/index.js";
const A = o.div`
  display: flex;
  flex-direction: column;

  ${({ animate: n }) => p({ animate: n, disableBackground: !0 })}

  ${a} {
    margin-bottom: 24px;
  }
`, C = o(c)`
  margin-top: 24px;
`, b = o.div`
  display: flex;
  flex-direction: column;
`, s = e`
  text-decoration: none;
  color: rgb(${t.colors.Alpha});

  &:hover {
    color: rgb(${t.colors.Alpha});
  }
`;
o(m)`
  ${r}
  ${s}

  align-self: center;
  margin-top: 12px;
`;
const d = e`
  padding: 8px 0;

  @media ${l.SCREEN_LG_UP} {
    padding-bottom: 16px;
    align-self: center;
  }
`, h = o(i)`
  ${d}
`;
export {
  C as CustomDealActionBar,
  b as DealActionContainer,
  A as DealActionContainerSkeleton,
  s as DealPageLinkStyle,
  h as DealStampSkeletonComponent
};
